import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/image/back-button.svg';
const _hoisted_1 = {
  class: "nav-bar-wrap"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "text-title"
};
import { onMounted, computed, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { closeWebview } from '@/utils/navitiveApi/common';
import { matchPhone } from '@/utils/tools';
export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: {
    title: null,
    backToClose: {
      type: Boolean
    },
    goBack: {
      type: Function
    },
    isMessage: null
  },
  setup(__props) {
    const props = __props;
    const {
      isIOS,
      isAndroid
    } = matchPhone();
    const iosDeviceDimension = reactive({
      tatusBarHeight: '30px',
      navigationBarHeight: '0px',
      tabBarFullHeight: '0px' // 底部安全区域
    });

    const router = useRouter();
    const onBack = () => {
      var _props$goBack, _props$goBack2;
      console.info('props.backToClose)', props.backToClose);
      if (props.backToClose) {
        console.info(11);
        closeWebview();
        return;
      }
      console.info(22);
      (_props$goBack = props === null || props === void 0 ? void 0 : (_props$goBack2 = props.goBack) === null || _props$goBack2 === void 0 ? void 0 : _props$goBack2.call(props)) !== null && _props$goBack !== void 0 ? _props$goBack : router.go(-1);
    };
    const topStyle = computed(() => {
      if (isIOS) {
        console.info('computed', iosDeviceDimension.tatusBarHeight);
        return {
          paddingTop: iosDeviceDimension.tatusBarHeight
        };
      } else {
        return {
          paddingTop: '30px'
        };
      }
    });
    onMounted(() => {
      // sysDeviceDimension().then(result => {
      //     try {
      //         const _result = result as string
      //         console.log('navbar', result)
      //         const obj = JSON.parse(_result)
      //         iosDeviceDimension.tatusBarHeight = obj.tatusBarHeight + 'px'
      //         console.log('tatusBarHeight', iosDeviceDimension.tatusBarHeight)
      //     } catch (e) {
      //         console.info('转换格式错误')
      //     }
      // })
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref: "navbar",
        class: _normalizeClass(["nav-bar header", {
          'is-android': _unref(isAndroid),
          'is-ios': _unref(isIOS),
          'nav-bar-message': props.isMessage
        }]),
        style: _normalizeStyle(_unref(topStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "back-button",
        onClick: onBack
      }, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1)]), _renderSlot(_ctx.$slots, "nav-right")], 6);
    };
  }
});